import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";

// Same GET /certificate/getData/:hash endpoint the public certificate
// viewer uses (features/students/certificateSlice.ts), but kept as its own
// slice/state: that other slice truncates `description` to 500 chars for
// display purposes, which would silently drop data from the "copiar
// contexto completo" debugging JSON on the Progress Audit screen.
export interface IProgressAuditCertificate {
  [key: string]: unknown;
}

interface ProgressAuditCertificateState {
  data: IProgressAuditCertificate | null;
  status: FetchStatus;
}

const initialState: ProgressAuditCertificateState = {
  data: null,
  status: FetchStatus.Idle,
};

export const progressAuditCertificateSlice = createSlice({
  name: "progressAuditCertificate",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IProgressAuditCertificate>) => {
      state.data = action.payload || null;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.data = null;
      state.status = FetchStatus.Error;
    },
    clear: (state) => {
      state.data = null;
      state.status = FetchStatus.Idle;
    },
  },
});

export const {
  fetching,
  fetched,
  error,
  clear: clearProgressAuditCertificate,
} = progressAuditCertificateSlice.actions;

export const fetchProgressAuditCertificateByHash = (hash: string) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `/certificate/getData/${hash}`,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.EVALUATION_SERVICE,
    })
  );
};

export const selectProgressAuditCertificate = (state: RootState) => state.progressAuditCertificate.data;

export default progressAuditCertificateSlice.reducer;
